module.exports = __webpack_public_path__ + "img/Standard_Bank_Logo.6a3ced7a.svg";